export default function commonMapStateToProps(state) {
  return {
    commonConfig: state.commonConfig,
    generalLinks: state.generalLinks,
  };
}
